import { render, staticRenderFns } from "./ReporteAbandonoLeadsTuSeguro.vue?vue&type=template&id=273d4097"
import script from "./ReporteAbandonoLeadsTuSeguro.vue?vue&type=script&lang=js"
export * from "./ReporteAbandonoLeadsTuSeguro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports